import _ from 'underscore';

import { Tableau } from '../../common/utilities/TableauLog';
import { CommonErrorCode, UserErrorCode } from '../../ts/helpers/ErrorCodes';
import { NotificationHelper } from '../components/helpers/NotificationHelper';

export enum ResultCode {
  InsufficientLicense = 31,
  SiteUserCreated = 12,
  SiteRoleNotChangedSiteUserQuota = 32,
  SystemUserCreated = 10
}

export class UserActionResultCode {

  // these are the codes that we know how to translate
  private static validUserActionCodes: _.Dictionary<boolean>;

  private constructor() {
    UserActionResultCode.validUserActionCodes = {};
    const codes = [1]
      .concat(_.range(10,16))
      .concat(_.range(20,22))
      .concat(_.range(30,33))
      .concat(_.range(40,43))
      .concat(_.range(50,61)); // note: 57 not in UserActionResultCode.java
    _.each(codes, (code: number) => UserActionResultCode.validUserActionCodes[code] = true);
  }

  public static readonly instance = new UserActionResultCode();

  public toLocalizedResultMessage(userActionCode: number, count: number = 1): string {
    userActionCode = this.normalizeUserActionCode(userActionCode);
    if (this.isValidUserActionCode(userActionCode)) {
      return NotificationHelper.userActionBulkOperationResultLocKeyDict[userActionCode](count);
    } else {
      Tableau.Logger().warn('unknown code ' + userActionCode);
      return '';
    }
  }

  public toLocalizedErrorMessage(userActionCode: number, count: number = 1, message?: string): string {
    userActionCode = this.normalizeUserActionCode(userActionCode);
    if (this.isValidUserActionErrorCode(userActionCode)) {
      return NotificationHelper.userActionBulkOperationErrorResultLocKeyDict[userActionCode](message);
    } else {
      Tableau.Logger().warn('unknown code ' + userActionCode);
      return '';
    }
  }

  private normalizeUserActionCode(userActionCode: number | string): number {
    if (typeof userActionCode === 'string') {
      // server bug: some codes are returned as strings others as numbers.
      return parseInt(userActionCode, 10) || 0;
    } else {
      return userActionCode;
    }
  }

  private isValidUserActionCode(code: number): boolean {
    return !!UserActionResultCode.validUserActionCodes[code];
  }

  private isValidUserActionErrorCode(code: number): boolean {
    return !!UserErrorCode[code] || !!CommonErrorCode[code];
  }
}

export default UserActionResultCode.instance;
